import ReactECharts from "echarts-for-react";
import { useRef } from "react";

import { NullableNumber, ReportItemType } from "../../types/Reports";
import { getOverallChartTooltipFormatter } from "./utils/reportChart";
import { convertSeriesDataToAdaptMinBarHeight } from "./utils/reportConvert";

type ReportBarChartProps = {
    itemType: ReportItemType;

    x: string[];
    y: NullableNumber[];

    yName: string;

    unit: string;

    color: string;
};

export default function ReportBarChart({
    itemType,
    x,
    y,
    yName,
    unit,
    color,
}: Readonly<ReportBarChartProps>) {
    const chartRef = useRef<ReactECharts | null>(null);

    // to use barMinHeight attribute, need to handle zero value
    let series = [
        {
            data: convertSeriesDataToAdaptMinBarHeight(itemType, y),
            type: 'bar',
            name: yName,
            itemStyle: {
                color: color,
            },
            barMinHeight: 1,
        },
    ];

    return (
        <div className="usage-bar-chart-container">
            <ReactECharts
                ref={chartRef}
                className="usage-bar-chart"
                theme="light"
                option={{
                    grid: {
                        left: 0,
                        right: 0,
                        top: 20,
                        bottom: 0,
                        containLabel: true,
                    },
                    xAxis: {
                        type: 'category',
                        splitLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLabel: {
                            interval: 1,
                        },
                        data: x,
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#EAEAEA1A',
                            }
                        },
                    },
                    series,
                    tooltip: {
                        trigger: 'axis',
                        formatter: getOverallChartTooltipFormatter(itemType, unit),
                    },
                }}
                notMerge={true}
                lazyUpdate={true}
            />
        </div>

    );
}
